import { LifeArea } from '@griply/types';
import { buildFilterSlices } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useTags } from 'features/tags';
import React, { useMemo } from 'react';
import { useRelationships } from 'shared/hooks/use-relationships';

import { FilterSlicesContext } from './context';

export type FilterSlicesProviderProps = {
  children: React.ReactNode;
};

export const FilterSlicesProvider: React.FC<FilterSlicesProviderProps> = ({
  children,
}) => {
  const goals = useGoals();
  const tags = useTags();
  const relationships = useRelationships();
  const lifeAreas = useLocalizedLifeAreas();

  const slices = useMemo(
    () =>
      buildFilterSlices(goals, tags, relationships, lifeAreas as LifeArea[]),
    [goals, tags, relationships, lifeAreas],
  );

  const value = useMemo(() => ({ slices }), [slices]);

  return (
    <FilterSlicesContext.Provider value={value}>
      {children}
    </FilterSlicesContext.Provider>
  );
};
